/**
 * <StudentHomeColumns> — le bas de l'accueil de l'élève : une colonne, ou deux quand la place y est.
 *
 * Sous le temps fort, le livre pose « Aujourd'hui » et la carte de défi l'un sous l'autre sur un
 * téléphone, côte à côte sur une tablette et un grand écran (chap. 17). Ici, ce qui se FAIT (son
 * prochain contrôle) puis le jeu : l'un sous l'autre quand le bloc est
 * étroit, côte à côte quand il est large, ce qui se fait sur trois cinquièmes, le jeu à côté.
 *
 * L'ordre des blocs ne change jamais, seule leur disposition : rien n'est remonté au passage du
 * seuil. Le seuil se lit sur la largeur de CE bloc (`useWidthAtLeast`), pas sur la fenêtre. Le
 * squelette de la page passe par le même composant : il bascule au même seuil.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { useWidthAtLeast } from "../../hooks/useWidthAtLeast"

/**
 * Deux colonnes à partir de cette largeur de BLOC : une fenêtre à `md` (800 px) moins les marges
 * de la page. La carte de quête y garde plus de 290 px.
 */
const TWO_COLUMNS_FROM = 760

export type StudentHomeColumnsProps = {
    /** Ce qui se fait : la grande colonne. */
    main: React.ReactNode
    /** Le jeu : la quête en cours, le rang. Absent : le reste garde toute la largeur. */
    game?: React.ReactNode
}

export function StudentHomeColumns(props: StudentHomeColumnsProps) {
    const { main, game } = props
    const { onLayout, atLeast } = useWidthAtLeast(TWO_COLUMNS_FROM)
    const columns = atLeast && game != null

    return (
        <View onLayout={onLayout} style={columns ? styles.columns : styles.stack}>
            <View style={columns ? [styles.stack, styles.main] : styles.stack}>{main}</View>
            {game != null && <View style={columns ? styles.side : undefined}>{game}</View>}
        </View>
    )
}

const styles = StyleSheet.create((theme) => ({
    stack: { gap: theme.spacing["6"] },
    columns: { flexDirection: "row", alignItems: "flex-start", gap: theme.spacing["6"] },
    main: { flexGrow: 3, flexShrink: 1, flexBasis: 0, minWidth: 0 },
    side: { flexGrow: 2, flexShrink: 1, flexBasis: 0, minWidth: 0 },
}))
